<script>
import BlockContent from '../UI/Content/BlockContent.vue'
import ModalDialog from '../UI/Modal/ModalDialog.vue'
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'
import SurrenderFormModal from '../Surrender/SurrenderFormModal.vue'
import CommissionList from './CommissionList.vue'

export default {
  components: { CommissionList, SurrenderFormModal, ModalDialog, BlockContent },
  mixins: [mixinComponent, globalVariablesMixin],
  props: {
    id: { type: Number, required: true },
    context: { type: String, required: true },
    wallet: { type: Boolean, required: false },
  },

  data() {
    return {
      profitability: {},
      methodSurrender: 'post',
      surrenderId: null,
      editInsurance: false,
      editChargeInsurance: false,
      amountInsurance: 0,
      amountChargeInsurance: 0,
      contract: {},
      displayServicesDetail: false,
      displayServicesBaseDetail: false,
    }
  },

  methods: {
    toggleServicesDetail() {
      this.displayServicesDetail = !this.displayServicesDetail
    },
    toggleServicesBaseDetail() {
      this.displayServicesBaseDetail = !this.displayServicesBaseDetail
    },
    detailIconClass(state) {
      return state ? 'fa-angle-down' : 'fa-angle-right'
    },
    getProfitability(request = false) {
      let url = `${this.context}/${this.id}/profitability?all=true`
      if (request) {
        url += '&refresh=true'
      }

      this.getJSON(url).then((profitability) => {
        if (
          profitability.profitabilities.some(
            (profitabilityEntry) => profitabilityEntry.profitabilityType.code === 'ER',
          ) &&
          profitability.surrenderId
        ) {
          this.methodSurrender = 'patch'
          this.surrenderId = profitability.surrenderId
        }
        this.profitability = profitability

        if (this.context == 'contracts') {
          this.getContract()
        } else if (this.context == 'quotations') {
          this.$parent.getSimulation()
        }
      })
    },
    getContract() {
      let urlParams = new URLSearchParams(window.location.search)

      let url = 'contracts/' + this.id + '/def'
      let uuid = urlParams.get('u')
      if (uuid) {
        url = 'free/' + url + '?uniqid=' + uuid
      }
      this.getJSON(url).then((json) => {
        this.addValue(this.contract, json.contract)
        this.contractNumber = json.contract.number
        this.addValue(this.def, json.config)
        this.page = urlParams.get('p') ? urlParams.get('p') : this.changePageStatus()
      })
    },
    surrenderSent(e) {
      this.surrenderId = e.json.id
      this.methodSurrender = 'patch'
      this.refresh()
    },
    commissionSent(commissions) {
      this.refresh()
    },
    showCommissionList() {
      if (this.profitability.commissionAmount == null) {
        this.$refs.commissionList.$refs.commissionForm.showForm()
      }
      $('#modal-commission').modal('show')
    },
    refresh() {
      this.getProfitability(true)
    },
    inputInsurance(id) {
      this.editInsurance = !this.editInsurance
      if (this.amountInsurance) {
        this.patchProfitabilityType(id, this.amountInsurance)
      }
    },
    inputChargeInsurance(id) {
      this.editChargeInsurance = !this.editChargeInsurance
      if (this.amountChargeInsurance) {
        this.patchProfitabilityType(id, this.amountChargeInsurance)
      }
    },
    editAmount(e, id, type) {
      if (type == 'SUB') {
        this.amountChargeInsurance = e.target.value
      } else {
        this.amountInsurance = e.target.value
      }
    },
    patchProfitabilityType(id, amount) {
      this.patchJSON(this.context + '/' + this.id + '/profitabilities/' + id, { amount: amount }).then((json) => {
        this.profitability = json
        if (this.context == 'contracts') {
          this.getContract()
        } else if (this.context == 'quotations') {
          this.$parent.getSimulation()
        }
      })
    },
  },

  beforeMount() {
    this.getProfitability()
  },
}
</script>
<template>
  <div id="page-profitability" class="tab-content">
    <BlockContent v-if="profitability?.profitabilities">
      <div class="row">
        <div class="col-md-5 card" style="padding: 1em; overflow-x: auto">
          <div class="d-flex justify-content-between">
            <h5 class="my-3">{{ $t('contract.client.profitability.title') }}</h5>
            <button
              v-if="!user.isReadOnly"
              class="btn btn-warning mb-3"
              @click="refresh"
              e2e-button="profitabilityRefresh"
            >
              {{ $t('profitability.refresh') }}
            </button>
          </div>
          <table class="table table-striped fs-16">
            <tbody>
              <tr class="text-success">
                <td class="contract-detail__cell contract-detail__cell__title">
                  {{
                    profitability.cession
                      ? $t('contract.client.profitability.rentInfo.amount')
                      : $t('contract.client.profitability.transferAmount')
                  }}
                </td>
                <td class="text-right" e2e-data="profitabilityTransferAmount">
                  {{ $n(Number(profitability.transferAmount), 'currency') }}
                </td>
                <td style="width: 5%"></td>
              </tr>
              <tr v-if="context == 'contracts'" class="text-success">
                <td
                  :class="
                    'contract-detail__cell contract-detail__cell__title ' +
                    (profitability.invoiceMiddleRent ? '' : 'text-decoration-through')
                  "
                >
                  {{ $t('contract.client.profitability.totalRentProrata') }}
                </td>
                <td
                  :class="'text-right ' + (profitability.invoiceMiddleRent ? '' : 'text-decoration-through')"
                  e2e-data="profitabilityTotalRentProrata"
                >
                  {{ $n(Number(profitability.totalRentProrata), 'currency') }}
                </td>
                <td style="width: 5%"></td>
              </tr>
              <tr class="text-success">
                <td class="contract-detail__cell contract-detail__cell__title">
                  {{ $t('contract.client.profitability.applicationFee') }}
                </td>
                <td class="text-right" e2e-data="profitabilityApplicationFee">
                  {{ $n(Number(profitability.applicationFee), 'currency') }}
                </td>
                <td style="width: 5%"></td>
              </tr>
              <tr class="text-success">
                <td class="contract-detail__cell contract-detail__cell__title">
                  {{ $t('contract.client.profitability.courtRegistryAmount') }}
                </td>
                <td class="text-right" e2e-data="profitabilityCourtRegistryAmount">
                  {{ $n(Number(profitability.courtRegistryAmount), 'currency') }}
                </td>
                <td style="width: 5%"></td>
              </tr>
              <tr
                class="text-success"
                v-if="profitability.services && Object.values(profitability.services).length > 0"
              >
                <td colspan="3" style="padding-right: 0">
                  <table class="fs-16">
                    <tbody>
                      <tr class="text-success" style="background-color: inherit">
                        <td
                          class="contract-detail__cell contract-detail__cell__title"
                          style="border: 0; padding-left: 0"
                        >
                          {{ $t('contract.client.profitability.services') }}
                        </td>
                        <td class="text-right" style="border: 0" e2e-data="profitabilityAmountServices">
                          {{ $n(Number(profitability.amountServices), 'currency') }}
                        </td>
                        <td
                          style="border: 0; width: 5%; cursor: pointer"
                          @click="toggleServicesDetail()"
                          e2e-button="toggleServicesDetail"
                        >
                          <i class="fa" :class="detailIconClass(displayServicesDetail)" style="font-size: 1.5em"></i>
                        </td>
                      </tr>
                      <tr
                        v-if="displayServicesDetail"
                        class="text-success"
                        v-for="service in Object.values(profitability.services)"
                        style="background-color: inherit"
                        :e2e-row="'profitabilityService-' + service.name"
                      >
                        <td
                          style="border: 0; padding-top: 0; padding-bottom: 0; font-size: 0.8em"
                          e2e-data="profitabilityServiceName"
                        >
                          {{ service.name }}
                        </td>
                        <td
                          class="text-right"
                          style="border: 0; padding-top: 0; padding-bottom: 0; font-size: 0.8em"
                          e2e-data="profitabilityServiceAmount"
                        >
                          {{ $n(Number(service.amount), 'currency') }}
                        </td>
                        <td style="width: 5%; border: 0"></td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr
                class="text-success"
                v-for="(value, index) in profitability?.profitabilities"
                :e2e-row="'profitability-' + index"
              >
                <template v-if="value.profitabilityType.type == 'ADD'">
                  <td class="contract-detail__cell contract-detail__cell__title" e2e-data="profitabilityTypeName">
                    {{ value.profitabilityType.name }}
                  </td>
                  <td class="text-right">
                    <template v-if="isTheme('olinn')">
                      <input
                        v-if="value.profitabilityType.name == 'Assurance' && editInsurance && !user.isReadOnly"
                        step="any"
                        pattern="^\\d*(\\.\\d{0,2}|\\,\\d{0,2})?$"
                        type="number"
                        class="form-control text-right"
                        :value="value.amount ? value.amount : '0.00'"
                        @input="editAmount($event, value.id, value.profitabilityType.type)"
                        e2e-input="profitabilityAmount"
                      />
                      <span
                        v-else-if="value.profitabilityType.name == 'Assurance' && amountInsurance"
                        e2e-data="profitabilityAmountInsurance"
                      >
                        {{ $n(Number(amountInsurance ? amountInsurance : ''), 'currency') }}
                      </span>
                      <span v-else e2e-data="profitabilityAmount">
                        {{ $n(Number(value.amount != null ? value.amount : ''), 'currency') }}
                      </span>
                    </template>
                    <template v-else>
                      <span e2e-data="profitabilityAmount">
                        {{ $n(Number(value.amount != null ? value.amount : ''), 'currency') }}
                      </span>
                    </template>
                  </td>
                  <td style="width: 5%">
                    <SurrenderFormModal
                      v-if="
                        ((context == 'contracts' && !wallet) ||
                          (context == 'quotations' && profitability.status != 'CLIENT_CONTRACT')) &&
                        value.profitabilityType.code == 'ER' &&
                        !user.isReadOnly
                      "
                      id-modal-page="page-profitability"
                      :finance-id="profitability.financeId"
                      :method="methodSurrender"
                      :surrender-id="surrenderId"
                      profitability
                      @surrenders-sent="surrenderSent"
                    />

                    <i
                      v-if="!user.isReadOnly && isTheme('olinn') && value.profitabilityType.name == 'Assurance'"
                      class="fa fa-plus"
                      @click="inputInsurance(value.id)"
                      e2e-input="profitabilityAddInsurance"
                    />
                  </td>
                </template>
              </tr>
              <tr class="text-success" v-if="!!profitability.repurchaseAmount">
                <td class="contract-detail__cell contract-detail__cell__title">
                  {{ $t('contract.client.profitability.repurchaseAmount') }}
                </td>
                <td class="text-right" e2e-data="profitabilityRepurchaseAmount">
                  {{ $n(Number(profitability.repurchaseAmount), 'currency') }}
                </td>
                <td style="width: 5%"></td>
              </tr>
              <tr class="text-success" style="border-top: 3px solid black; border-bottom: 3px solid black">
                <td class="contract-detail__cell contract-detail__cell__title">
                  {{ $t('contract.client.profitability.profitabilityAddTotal') }}
                </td>
                <td class="text-right" e2e-data="profitabilityAddTotal">
                  {{ $n(Number(profitability.profitabilityAddTotal), 'currency') }}
                </td>
                <td style="width: 5%"></td>
              </tr>
              <tr v-if="profitability.cession" class="text-danger">
                <td class="contract-detail__cell contract-detail__cell__title">
                  {{ $t('contract.client.profitability.equipmentsAmount') }}
                </td>
                <td class="text-right" e2e-data="profitabilityEquipmentsAmount">
                  {{ $n(Number(profitability.equipmentsAmount), 'currency') }}
                </td>
                <td style="width: 5%"></td>
              </tr>
              <tr
                class="text-danger"
                v-for="(value, index) in profitability.profitabilities"
                :key="`profitability-${index}`"
                :e2e-row="'profitability-' + index"
              >
                <template v-if="value.profitabilityType.type == 'SUB'">
                  <td class="contract-detail__cell contract-detail__cell__title" e2e-data="profitabilityTypeName">
                    {{ value.profitabilityType.name }}
                  </td>
                  <td class="text-right">
                    <template v-if="isTheme('olinn')">
                      <input
                        v-if="value.profitabilityType.name == 'Assurance' && editChargeInsurance && !user.isReadOnly"
                        step="any"
                        pattern="^\d*(\.\d{0,2}|\,\d{0,2})?$"
                        type="number"
                        class="form-control text-right"
                        :value="amountChargeInsurance ? amountChargeInsurance : value.amount ? value.amount : '0.00'"
                        @input="editAmount($event, value.id, value.profitabilityType.type)"
                        e2e-input="profitabilityAmount"
                      />
                      <span
                        v-else-if="value.profitabilityType.name == 'Assurance' && amountChargeInsurance"
                        e2e-data="profitabilityAmountChargeInsurance"
                      >
                        {{ $n(Number(amountChargeInsurance ? amountChargeInsurance : ''), 'currency') }}
                      </span>
                      <span v-else e2e-data="profitabilityAmount">{{
                        $n(Number(value.amount != null ? value.amount : ''), 'currency')
                      }}</span>
                    </template>
                    <span v-else e2e-data="profitabilityAmount">
                      {{ $n(Number(value.amount != null ? value.amount : ''), 'currency') }}
                    </span>
                  </td>
                  <td style="width: 5%">
                    <i
                      v-if="isTheme('olinn') && value.profitabilityType.name == 'Assurance' && !user.isReadOnly"
                      class="fa fa-plus"
                      @click="inputChargeInsurance(value.id)"
                      e2e-input="chargeInsurance"
                    />
                  </td>
                </template>
              </tr>
              <tr v-if="context == 'contracts'" class="text-danger">
                <td class="contract-detail__cell contract-detail__cell__title">
                  {{ $t('contract.client.profitability.refinancerApplicationFee') }}
                </td>
                <td class="text-right" e2e-data="profitabilityRefinancerApplicationFee">
                  {{ $n(Number(profitability.refinancerApplicationFee), 'currency') }}
                </td>
                <td style="width: 5%"></td>
              </tr>
              <tr class="text-danger" v-if="profitability.services && Object.values(profitability.services).length > 0">
                <td colspan="3" style="padding-right: 0">
                  <table class="fs-16">
                    <tbody>
                      <tr class="text-danger" style="background-color: inherit">
                        <td
                          class="contract-detail__cell contract-detail__cell__title"
                          style="border: 0; padding-left: 0"
                        >
                          {{ $t('contract.client.profitability.services') }}
                        </td>
                        <td class="text-right" style="border: 0" e2e-data="profitabilityAmountBaseServices">
                          {{ $n(Number(profitability.amountBaseServices), 'currency') }}
                        </td>
                        <td
                          style="border: 0; width: 5%; cursor: pointer"
                          @click="toggleServicesBaseDetail()"
                          e2e-input="toggleServicesBaseDetail"
                        >
                          <i
                            class="fa"
                            :class="detailIconClass(displayServicesBaseDetail)"
                            style="font-size: 1.5em"
                          ></i>
                        </td>
                      </tr>
                      <tr
                        v-if="displayServicesBaseDetail"
                        class="text-danger"
                        v-for="service in Object.values(profitability.services)"
                        style="background-color: inherit"
                        :e2e-row="'profitabilityService-' + service.name"
                      >
                        <td
                          style="border: 0; padding-top: 0; padding-bottom: 0; font-size: 0.8em"
                          e2e-data="profitabilityServiceName"
                        >
                          {{ service.name }}
                        </td>
                        <td
                          class="text-right"
                          style="border: 0; padding-top: 0; padding-bottom: 0; font-size: 0.8em"
                          e2e-data="profitabilityServiceAmountBase"
                        >
                          {{ $n(Number(service.amountBase), 'currency') }}
                        </td>
                        <td style="width: 5%; border: 0"></td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr class="text-danger">
                <td class="contract-detail__cell contract-detail__cell__title">
                  {{ $t('contract.client.profitability.commission') }}
                </td>
                <td class="text-right" e2e-data="profitabilityCommissionAmount">
                  {{ $n(Number(profitability.commissionAmount), 'currency') }}
                </td>
                <td style="width: 5%">
                  <a
                    v-if="
                      !user.isReadOnly &&
                      ((context == 'contracts' && !wallet) ||
                        (context == 'quotations' && profitability.status != 'CLIENT_CONTRACT'))
                    "
                    class="cursor-pointer"
                    role="button"
                    @click="showCommissionList"
                    e2e-input="showCommissionList"
                  >
                    <i class="fa fa-plus"></i>
                  </a>
                </td>
              </tr>
              <tr v-if="!!profitability.refinancerOutstandingAmount" class="text-danger">
                <td class="contract-detail__cell contract-detail__cell__title">
                  {{ $t('contract.client.profitability.refinancerOutstandingAmount') }}
                </td>
                <td class="text-right" e2e-data="profitabilityRefinancerOutstandingAmount">
                  {{ $n(Number(profitability.refinancerOutstandingAmount), 'currency') }}
                </td>
                <td style="width: 5%"></td>
              </tr>
              <tr class="text-danger" style="border-top: 3px solid black; border-bottom: 3px solid black">
                <td class="contract-detail__cell contract-detail__cell__title">
                  {{ $t('contract.client.profitability.profitabilitySubTotal') }}
                </td>
                <td class="text-right" e2e-data="profitabilitySubTotal">
                  {{ $n(Number(profitability.profitabilitySubTotal), 'currency') }}
                </td>
                <td style="width: 5%"></td>
              </tr>
              <tr>
                <td class="contract-detail__cell contract-detail__cell__title">
                  {{ $t('contract.client.profitability.profitability') }}
                </td>
                <td class="text-right" e2e-data="profitabilityMargin">
                  {{ $n(Number(profitability.profitability), 'currency') }}
                </td>
                <td style="width: 5%"></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-1"></div>
        <div class="col-md-5 card indicators">
          <h5 class="my-3">{{ $t('profitability.indicators.title') }}</h5>
          <div class="row">
            <div class="col label">{{ $t('profitability.totalPercentProfitability') }}</div>
            <div class="col value" e2e-data="profitabilityTotalPercentProfitability">
              {{ $n(Number(profitability.totalPercentProfitability), 'decimal') }}%
            </div>
          </div>
          <div class="row" v-if="profitability.totalPercentCession">
            <div class="col label">{{ $t('profitability.totalPercentCession') }}</div>
            <div class="col value" e2e-data="profitabilityTotalPercentCession">
              {{ $n(Number(profitability.totalPercentCession), 'decimal') }}%
            </div>
          </div>
          <div class="row" v-if="profitability.purchaseRate">
            <div class="col label">{{ $t('profitability.purchaseRate') }}</div>
            <div class="col value" e2e-data="profitabilityPurchaseRate">
              {{ $n(Number(profitability.purchaseRate), 'decimal') }}%
            </div>
          </div>
          <div class="row" v-if="profitability.servicesPercentProfitability">
            <div class="col label">{{ $t('profitability.servicesPercentProfitability') }}</div>
            <div class="col value" e2e-data="profitabilityServicesPercentProfitability">
              {{ $n(Number(profitability.servicesPercentProfitability), 'decimal') }}%
            </div>
          </div>
        </div>
      </div>
    </BlockContent>
    <BlockContent v-else>
      <div class="row">
        <div class="col-md-5 card" style="padding: 1em; overflow-x: auto">
          <div class="row py-3 mb-3 mx-3 loading"></div>
          <div class="row py-3 mb-3 mx-3 loading"></div>
          <div class="row py-3 mb-3 mx-3 loading"></div>
          <div class="row py-3 mb-3 mx-3 loading"></div>
        </div>
      </div>
    </BlockContent>
    <ModalDialog
      v-if="(context == 'contracts' && !wallet) || context == 'quotations'"
      id="modal-commission"
      id-modal-page="page-profitability"
      class-modal-dialog="modal-lg"
      title-t="commission.title"
      style="z-index: 1041"
      e2e-modal="commissions"
    >
      <template #body>
        <CommissionList
          ref="commissionList"
          id-modal-page="page-profitability"
          :finance-id="Number(profitability.financeId)"
          :commissions="profitability.commissions"
          @commissions-sent="commissionSent"
        />
      </template>
      <template #footer>
        <button type="button" class="btn btn-lg btn-info" data-dismiss="modal" e2e-button="close">
          {{ $t('main.close') }}
        </button>
      </template>
    </ModalDialog>
  </div>
</template>
